<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Date Range"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                </base-input>
                            </div>
                            <div class="col-md-4">
                                <base-input label="Group By" >
                                    <select class="form-control" size="large" v-model="inputGroupBy" >
                                        <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Site">
                                    <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Payment Type" >
                                    <a-select mode="multiple" v-model="inputPaymentType" showSearch placeholder="All Payment Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" >
                                        <a-select-option v-for="option in paymentTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;"
                                        @click.prevent="generateReport">
                                  Generate Report in PDF
                                </button> 
                                <download-excel
                                    worksheet="Sales Reports"
                                    :name="excelFileName"
                                    type="xls"
                                    :fetch="excelData"
                                    :fields="excelHeaders">
                                    <button class="btn btn-sm btn-success float-right"
                                            style="border-radius: 24px; border:0px; width: 20%;">
                                      Generate Report in Excel
                                    </button>
                                </download-excel>&nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import reportUtils from '../../components/reportUtils'
    
    
        function formatNumber(num) {
          return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    
        import {
            mapState
        } from 'vuex'
    import { PaperSize } from 'exceljs';
    
        export default {
            data() {
              return {
                spinning: false,
                currentDocumentTypeId: 0,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'payment_type_id',
                groupOptions: [
                  {key: 'site_id', value: 'Site'},
                  {key: 'payment_type_id', value: 'Payment Type'},
                  {key: 'user_id', value: 'Cashier'},
                  {key: 'terminal_id', value: 'terminal'}
                ],
                inputPaymentType: [],
                paymentTypeOptions: [],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                forfeitedAmmountReports: [],
                excelFileName: `Forfeited_Ammount_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}.xls`,
                excelHeaders: {},
                validTerminals: null,
                selectedCashierId: "0",
                validCashiers: null,
              }
            },
            
            mounted: async function () {
                var component_x = this;

                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
                let siteId = secureStorage.getItem("defaultSiteId")
                this.inputSite = [siteId]
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
    
                var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/get_valid_terminals', null)
                this.validTerminals = terminal_data  
    
                var cashier_data = await HTTPRequest.getRequest(this.endPoint + 'users/get_valid_cashiers', null)
                this.validCashiers = cashier_data
    
                var payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
                component_x.paymentTypeOptions = payment_types;

                // Define an array of desired payment type names
                var desiredNames = ["Credit Memo", "Coupon", "Gift Certicate"];

                // Use the filter method to filter payment types based on their names
                component_x.paymentTypeOptions = component_x.paymentTypeOptions.filter(paymentType => desiredNames.includes(paymentType.name));

                // If you want to sort the filtered payment types, you can use the sort method
                component_x.paymentTypeOptions.sort((a, b) => a.name.localeCompare(b.name));
            },
            computed: {
                ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
            },
            methods: {
                moment,
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                openNotificationWithIcon(type, msg) {
                    if(type == 'error'){
                        this.$notification[type]({
                            message: 'Export Error',
                            description: msg
                        });
                    }else if(type == 'warning'){
                        this.$notification[type]({
                            message: 'No Data Found',
                            description: msg
                        });
                    }
                },
                async exportRequest() {
                  this.spinning= true;
                  let request = {};
                  let errorMsg = "";
    
                  
                  let payment_types = []
                  payment_types.push(...this.inputPaymentType)
    
                  if(this.inputDate.length == 0){
                    errorMsg = 'Please make sure to check your current filters.';
                    this.spinning= false;
                    return { request, errorMsg };
                  }
    
                  request = await HTTPRequest.getRequest(this.endPoint + 'forfeited_amount_report?site_id=' + this.inputSite +
                  '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:ss:mm') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:ss:mm') +
                  '&payment_type_id=' + payment_types + '&user_id=' + this.selectedCashierId + '&group=' + this.inputGroupBy, null)
    
                  if(request.error) {
                    errorMsg = request.error;
                  }
                  
                  this.spinning= false;
                  return { request, errorMsg }
                },
                async excelData() {
                  const { request, errorMsg } = await this.exportRequest();
    
                  if (errorMsg.length > 0) {
                    this.openNotificationWithIcon('error', errorMsg);
                      return;
                  }
    
                  const siteSpecificRequest = request;
    
                  if (siteSpecificRequest.length < 1) {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                    return
                  }
    
                  let jsonData = [];
                  this.excelFileName = `Forfeited_ammount_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}.xls`;
    
                    this.excelHeaders = {
                      "Date": "date",
                      "TransID": "TransId",
                      "SI#": "invoiceNo",
                      "Tender": "tender",
                      "Tender Details": "tenderDetails",
                      "Amount": "amount",
                      "Forfeited Amount": "forfeitedAmount",
                      "Cashier": "cashierName",
                      "Branch": "siteName",
                    }
    
                    siteSpecificRequest.map(siteData => {
                      const reportDetails = siteData.report_details;
                      if (reportDetails) {
                        reportDetails.map(detail => {
    
                          let detailObj = {
                            date:  moment(detail.created_at).format('MM/DD/YYYY'),
                            TransId: detail.trans_id,
                            invoiceNo: detail.invoice_no,
                            tender: detail.tender,
                            tenderDetails: detail.tender_details,
                            amount:detail.amount,
                            forfeitedAmount:detail.forfeited_amount,
                            cashierName: detail.cashier_name,
                            siteName: detail.site_name,
                          }
    
                          jsonData.push(detailObj)
                        })
                      }
                    })
    
                  return jsonData;
                },
                generateReport: async function () {
                    this.spinning= true;
                    const { request, errorMsg } = await this.exportRequest();
    
                    if (errorMsg.length > 0) {
                      this.openNotificationWithIcon('error', errorMsg);
                      return;
                    }
    
                    var siteSpecific = request;
    
                    if (siteSpecific.length < 1) {
                      this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                      this.spinning= false;
                      return;
                    }
    
                    let paperSize = 'legal' 
    
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: paperSize});
                    try {
                        let reportLogo = document.getElementById('reportLogo');
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    } catch (error) {
                        console.log(error)
                    }
    
                    let headers = [
                            [
                                {content: 'Date', styles: {halign: 'center'}},
                                {content: 'Trans ID', styles: {halign: 'center'}},
                                {content: 'SI #', styles: {halign: 'center'}},
                                {content: 'Tender', styles: {halign: 'center'}},
                                {content: 'Tender Details', styles: {halign: 'center'}},
                                {content: 'Amount', styles: {halign: 'center'}},
                                {content: 'Forfieted Amount', styles: {halign: 'center'}},
                                {content: 'Cashier', styles: {halign: 'center'}},
                                {content: 'Branch', styles: {halign: 'center'}}
                            ]
                    ];
        
                    for(var x=0; x < siteSpecific.length; x++){
                            this.forfeitedAmmountReports = siteSpecific[x].report_details
    
                            if(x > 0 && this.forfeitedAmmountReports.length > 0){
                                doc.addPage();
                            }
    
                            let total_amount = 0
                            let grand_total_amount = 0
    
                            // grouping
                            let reportData = [];
                            let grouper = 'start'
                            let type_header = 'start'
    
                            if(this.forfeitedAmmountReports.length > 0){
                                let arr = 'start'
                                for(var i=0; i < this.forfeitedAmmountReports.length; i++){
                                    let reportLine = this.forfeitedAmmountReports[i]
    
                                    // grouping
                                    let grouper_name;
                                    switch (this.inputGroupBy) {
                                        case 'payment_type_id':
                                            grouper_name = reportLine.tender;
                                            break;
                                        case 'user_id':
                                            grouper_name = reportLine.cashier_name;
                                            break;
                                        case 'site_id':
                                            grouper_name = reportLine.site_name;
                                            break;
                                        case 'terminal_id':
                                            grouper_name = reportLine.terminal_name;
                                            break;
                                        default:
                                            // Handle the case where inputGroupBy is not recognized.
                                            break;
                                    }

                                    if (grouper == 'start' || grouper != grouper_name) {
                                        let detail_header = [{ content: grouper_name, colSpan: 3, styles: { halign: 'left', fontStyle: 'bold' } }];
                                        reportData.push(Object.assign({}, detail_header));
                                    }

                                    grouper = grouper_name;

                                    let detail = []
                                    
                                    detail = [
                                        moment(reportLine.created_at).format('MM/DD/YYYY hh:mm a'),
                                        reportLine.trans_id,
                                        reportLine.invoice_no,
                                        reportLine.tender,
                                        reportLine.tender_details,
                                        reportLine.amount,
                                        reportLine.forfeited_amount,
                                        reportLine.cashier_name,
                                        reportLine.site_name,
                                    ]
                                        
                                    reportData.push(Object.assign({}, detail))
    
                                    total_amount += Number(reportLine.amount)
                                    grand_total_amount += Number(reportLine.amount)
    
                                    if(i == this.forfeitedAmmountReports.length - 1){
                                       
                                        let sub_detail = []
                                        let spacer = grouper_name
                                    
                                        sub_detail = ["", "", "", "",
                                        {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}},
                                        this.convertToCurrency(total_amount),'', '', '', '']
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                        
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', '', '', 'Grand Total :',
                                        this.convertToCurrency(grand_total_amount),'', '', ''
                                        ]));
                                            
                                    } else {
                                        let current_grouper = ""
                                        let next_grouper = ""
                                        current_grouper = reportLine.tender
                                        next_grouper = this.forfeitedAmmountReports[i+1].tender
    
                                        if(current_grouper != next_grouper){
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            let sub_detail = []
    
                                            let spacer = grouper_name
    
                                            sub_detail = ["", "", "", "",
                                                {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}},
                                                this.convertToCurrency(total_amount),'', '', '']
    
                                            reportData.push(Object.assign({}, sub_detail))
    
                                            total_amount = 0
                                        }
                                        
                                    }
                                }
                                let colStyles = {
                                    0: {cellWidth: 35},
                                    1: {cellWidth: 20},
                                    2: {cellWidth: 20},
                                    3: {cellWidth: 30},
                                    4: {cellWidth: 90},
                                    5: {cellWidth: 35},
                                    6: {cellWidth: 30},
                                    7: {cellWidth: 40},
                                    8: {cellWidth: 30},
                                }
    
                                let design_x = 525
                                let design_y = 225
    
                            
    
                                doc.setFontSize(14);
                                doc.setFontType("bold");
    
                                doc.text(15,20,"Forfeited Ammount Report")
                                doc.setFontType("normal");
                                doc.setFontSize(10);
                                
                                doc.text(340,20,siteSpecific[x].report_details[0].site_name, "right")
                                doc.text(15,25,"As of " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
    
                                doc.autoTable({
                                    startY: 30, 
                                    head: headers, 
                                    body: reportData, 
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    headStyles: {
                                        lineWidth: 0.15,
                                        cellPadding: 2
                                    },
                                    styles: {
                                        cellPadding: 1.0, fontSize: 9,
                                        halign: 'right'
                                    },
                                    columnStyles: colStyles,
                                    didParseCell: function(data) {
                                        if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                            data.cell.styles.fillColor = [0, 0, 0]
                                            data.cell.styles.fontSize = 1
                                            data.cell.styles.cellPadding = 0
                                        } else if (data.row.section == 'body' && (data.row.raw[5] == 'Total :' && data.row.raw[5] == 'Grand Total :')){
                                            data.cell.styles.fontStyle = 'bold'
                                        }
                                    }
                                });
    
                                let pageCount = doc.internal.getNumberOfPages();
                                let printed_by = secureStorage.getItem("email")
                                let group_text = "Tender"
                                if(printed_by == null){
                                    printed_by = ''
                                }
    
                                for(let i = 1; i <= pageCount; i++) {
                                    doc.setPage(i);
                                    reportUtils.pdfTools.addFooter(doc, printed_by, "Forfeited Ammount Report" + group_text, design_x, design_y, i, pageCount)
                                }
                            }
                    }
    
                        window.open(URL.createObjectURL(doc.output("blob")))
                }
            }
        };
    </script>
    
    <style></style>
    